var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "div",
        [
          _c("div", { staticClass: "header-actions" }, [_c("CorpId")], 1),
          _vm._v(" "),
          _c("p", { staticClass: "mt-0" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$l10n.__(
                    "Cette section concerne les utilisateurs, vous retrouvez ici les applications que vous utilisez. Vous pouvez à tout moment interdire l'accès d'une application à votre compte. Une fois l'accès revoqué, ils vous suffira de vous reconnecter à votre compte via l'application pour le restaurer"
                  )
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "acenter pb-2" },
            [
              _c("quick-filter", {
                attrs: { filters: _vm.filters, selected: _vm.selected },
                on: { selected: _vm.filterOn }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.appWithStaff.length
            ? _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.appWithStaff, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "consumer_i_app_name",
                      label: _vm.$t.__("common.labels.name")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", { staticClass: "flex-level" }, [
                                _c("div", {
                                  class: [
                                    "chip",
                                    "label-chip",
                                    "mr-2",
                                    scope.row.token_status == "enabled"
                                      ? "chip-primary"
                                      : "chip-danger"
                                  ]
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "flex label-value",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      scope.row.consumer_i_app_name
                                    )
                                  }
                                })
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2581470331
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "consumer_i_owner_mail",
                      label: _vm.$t.__("developerPage.ThirdPartyApps.developer")
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "user_user_id",
                      label: _vm.$t.__("common.labels.staff")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.user_user_type === "staff"
                                ? _c(
                                    "div",
                                    { staticClass: "flex-level" },
                                    [
                                      _c("avatar-inline", {
                                        attrs: { data: scope.row.staff }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      688678605
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t.__(
                        "developerPage.ThirdPartyApps.last_connection"
                      )
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$filters.dateFormatter(
                                      scope.row.user_last_login,
                                      "NORMAL_DATE_TIME",
                                      false
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1081929862
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "consumer_i_owner_web",
                      label: _vm.$t.__("common.labels.web_site")
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "right",
                      label: _vm.$t.__("common.labels.actions"),
                      width: "200"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.token_status === "enabled"
                                ? _c(
                                    "link-button",
                                    {
                                      staticClass: "mr-3",
                                      on: {
                                        clicked: function($event) {
                                          return _vm.deleteApp(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$l10n.__("Désactiver l'accès")
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3702644268
                    )
                  })
                ],
                1
              )
            : _c("div", { staticClass: "placeholder well" }, [
                _c("p", [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Vous n'utilisez aucune application tierce pour le moment"
                        )
                      ) +
                      "\n        "
                  )
                ])
              ])
        ],
        1
      )
    : _c("preloader", { attrs: { background: false, display: true } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }